import { usePathname } from '@/i18n/navigation';
import { getCart } from '@/services/cart';
import { getCookie } from 'cookies-next';
import { setCookie } from 'cookies-next/client';
import { useTranslations } from 'next-intl';
import { useSelectedLayoutSegments } from 'next/navigation';
import { useMemo, useRef } from 'react';
import useSWR from 'swr';
import DrawerPanel from './drawer-panel';
import SmallCart from './small-cart';

const CartPopUpWrapperV2 = ({ state }) => {
  const t = useTranslations('cart');
  const mage = getCookie('mage');
  const quote = getCookie('quote');
  const pathname = usePathname();
  const menuRef = useRef();
  const segments = useSelectedLayoutSegments();
  const isProductPage = segments?.includes('(product)');

  const hideOnMobile =
    pathname.startsWith('/cart') || pathname.startsWith('/checkout')
      ? 'max-md:hidden'
      : '';

  const cartKey = useMemo(() => {
    if (!quote) return null;
    const itemIdsKey = state?.cartItems
      ?.map((item) => `${item.item_id}:${item.qty}`)
      .join(',');

    return ['total_segments', quote, itemIdsKey];
  }, [quote, state?.cartItems]);

  const { isLoading } = useSWR(cartKey, () => getCart({ mage, quote }), {
    revalidateOnFocus: false,
    onSuccess: async (res) => {
      if (res?.data?.data) {
        if (res?.data?.quoteId !== quote) {
          setCookie('quote', res?.data?.quoteId);
        }
        const totalSegments = res.data.data.total_segments || [];
        const shippingValue =
          totalSegments.find((e) => e?.code === 'shipping')?.value ?? 0;

        const updatedSegments = totalSegments.map((segment) => {
          if (segment.code === 'grand_total') {
            return {
              ...segment,
              value:
                segment.value > 0
                  ? segment.value - shippingValue
                  : segment.value,
            };
          }
          return segment;
        });
        state?.setTotalSegments(updatedSegments);
        state?.setCart(res.data.data);
      }
    },
  });

  const styleInProduct = isProductPage
    ? 'bottom-0 left-0 w-full md:w-auto md:bottom-5 md:left-5'
    : state?.openDrawer
      ? 'bottom-0 left-0 w-full md:w-auto md:bottom-5 md:left-5'
      : `md:bottom-5 bottom-[59px] max-md:left-0 max-md:right-0 md:left-5`;

  return (
    <div
      className={`fixed ${styleInProduct} z-24 ${hideOnMobile}`}
      ref={menuRef}
    >
      <div className={`${isProductPage && 'hidden md:block'}`}>
        <SmallCart
          t={t}
          isPanelOpen={state?.openDrawer}
          togglePanel={state?.toggleDrawer}
          togglePopup={state?.togglePopup}
          cartItems={state?.cartItems}
          isLoading={isLoading}
          totalSegments={state?.totalSegments}
        />
      </div>
      {state?.openDrawer && (
        <DrawerPanel
          cartItems={state?.cartItems}
          togglePanel={state?.toggleDrawer}
          t={t}
          togglePopup={state?.togglePopup}
          toggleDrawer={state?.toggleDrawer}
          isLoading={isLoading}
          relatedProducts={state?.relatedProducts}
          totalSegments={state?.totalSegments}
        />
      )}
    </div>
  );
};

export default CartPopUpWrapperV2;
